import React from 'react';

import { ACTION } from 'constants/index';

import Button, { buttonType, buttonColor } from 'Components/Button';
import EditApplicationButton from 'Components/EditApplicationButton';

export default function Actions({id, responseId, reportStatus, actions, performAction}) {
  const eSignActionsList = [];
  const responseActionsList = [];
  const reportActionList = [];

  if (actions.includes(ACTION.E_SIGN_REPORT)) {
    eSignActionsList.push(
      <Button
        label={ACTION.E_SIGN_REPORT}
        buttonClassName='_height_40 _width_160 _margin_right_20 _margin_top_30'
        onClick={performAction(ACTION.E_SIGN_REPORT, id)}
        type={buttonType.primary}
        color={buttonColor.darkGreen}
      />
    );
  }

  if (actions.includes(ACTION.NEED_RESPONSE)) {
    responseActionsList.push(
      <Button
        label={ACTION.NEED_RESPONSE}
        buttonClassName='_height_40 _width_120 _margin_right_20  _margin_top_30'
        onClick={performAction(ACTION.NEED_RESPONSE, id)}
        type={buttonType.primary}
        color={buttonColor.darkGreen} />
    );
  }

  if (actions.includes(ACTION.DELETE_RESPONSE)) {
    responseActionsList.push(
      <Button
        label={ACTION.DELETE_RESPONSE}
        buttonClassName='_height_40 _width_120 _margin_right_20  _margin_top_30'
        onClick={performAction(ACTION.DELETE_RESPONSE, id)}
        type={buttonType.primary}
        color={buttonColor.darkRed} />
    );
  }

  if (actions.includes(ACTION.APPROVE_WITH_RESPONSE)) {
    responseActionsList.push(
      <Button
        label={ACTION.APPROVE_WITH_RESPONSE}
        buttonClassName='_height_40 _width_120 _margin_right_20  _margin_top_30'
        onClick={performAction(ACTION.APPROVE_WITH_RESPONSE, id)}
        type={buttonType.primary}
        color={buttonColor.darkGreen}
      />
    );
  }

  if (actions.includes(ACTION.INCOMPLETE_REPORT)) {
    reportActionList.push(
      <Button
        label={ACTION.INCOMPLETE_REPORT}
        buttonClassName='_height_40 _width_120 _margin_right_20  _margin_top_30'
        onClick={performAction(ACTION.INCOMPLETE_REPORT, id)}
        type={buttonType.primary}
        color={buttonColor.lightBlue}
      />
    );
  }

  if (actions.includes(ACTION.APPROVE_WITHOUT_RESPONSE)) {
    reportActionList.push(
      <Button
        label={ACTION.APPROVE_WITHOUT_RESPONSE}
        buttonClassName='_height_40 _width_160 _margin_right_20  _margin_top_30'
        onClick={performAction(ACTION.APPROVE_WITHOUT_RESPONSE, id)}
        type={buttonType.primary}
        color={buttonColor.green}
      />
    );
  }

  if (actions.includes(ACTION.RESUBMIT)) {
    reportActionList.push(
      <Button
        label={ACTION.RESUBMIT}
        buttonClassName='_height_40 _width_120 _margin_right_20 _margin_top_30'
        onClick={performAction(ACTION.RESUBMIT, id)}
        type={buttonType.primary}
        color={buttonColor.green}
      />
    );
  }

  if (actions.includes(ACTION.INCOMPLETE_RESPONSE)) {
    reportActionList.push(
      <Button
        label={ACTION.INCOMPLETE_RESPONSE}
        buttonClassName='_height_40 _width_120 _margin_right_20  _margin_top_30'
        onClick={performAction(ACTION.INCOMPLETE_RESPONSE, responseId)}
        color={buttonColor.lightBlue}
      />
    );
  }

  if (actions.includes(ACTION.APPROVE_RESPONSE)) {
    reportActionList.push(
      <Button
        label={ACTION.APPROVE_RESPONSE}
        buttonClassName='_height_40 _width_120 _margin_right_20  _margin_top_30'
        onClick={performAction(ACTION.APPROVE_RESPONSE, responseId)}
        color={buttonColor.green}
      />
    );
  }

  if (actions.includes(ACTION.SUBMIT_RESPONSE)) {
    reportActionList.push(
      <Button
        label={ACTION.SUBMIT_RESPONSE}
        buttonClassName='_height_40 _width_120 _margin_right_20 _margin_top_30'
        onClick={performAction(ACTION.SUBMIT_RESPONSE, responseId)}
        color={buttonColor.green}
      />
    );
  }

  if (!(reportActionList.length + responseActionsList.length + eSignActionsList.length)) return null;

  const firstDelimiterNeeded = eSignActionsList.length && (reportActionList.length || responseActionsList.length);
  const secondDelimiterNeeded = reportActionList.length && responseActionsList.length;

  return (
    <section className='scene_section detailsScene__change-status-section'>
      <header>Actions</header>
      {actions.includes(ACTION.EDIT) && (
        <EditApplicationButton
          className='_height_40 _width_pc_100 _max_width_180 _margin_right_30 _margin_top_30'
          onClick={performAction(ACTION.EDIT, id)}
        />
      )}
      {eSignActionsList}

      {!!firstDelimiterNeeded &&
      <div className="__delimiter_vertical" />
      }

      {responseActionsList}

      {!!secondDelimiterNeeded &&
      <div className="__delimiter_vertical" />
      }

      {reportActionList}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Actoins.jsx